import { baseApi } from 'core/api';

const state = () => ({
    _items: null
});

const getters = {
    shortcodes: (state) => state._items
};

const actions = {
    getNumbersShortcodes(retry) {
        if (retry === true) {
            this._setShortcodesRetryLoading();
        }

        return baseApi
            .get(`core/numbers/shortcodes`)
            .then(response => {
                this._setShortcodesLoaded(response.data);

                return response;
            })
            .catch(() => {
                this._setShortcodesErrorLoading();
            });
    },

    _setShortcodesLoaded(data) {
        this._items = data;
    },

    _setShortcodesRetryLoading() {
        this._items = null;
    },

    _setShortcodesErrorLoading() {
        this._items = false;
    },
};



export default {
    state,
    getters,
    actions,
};
